import { ProductItemTypes } from '../enums';
import { ProductItemPaginationModel } from '../models';
import { ProductItemSchema, ProductItemsResponseSchema } from '../schemas';
import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getProductItems = async (pagination: ProductItemPaginationModel, type: ProductItemTypes, userEntrieOnly: boolean = false): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/products/items?page=${pagination.page}&limit=${pagination.limit}&status=${pagination.status ?? ''}&type=${type ?? ''}&orderBy=${''}&userEntriesOnly=${userEntrieOnly}`)
      .then((response) => handleResponse(response, ProductItemsResponseSchema))
      .catch(handleError);
};
